import { Chip, Icon, Tooltip } from '@mui/material';

export default function Select(props) {
    const { filter, handleDelete, onClick, value } = props;
    const selectedOptions = filter.options.filter(option => value.includes(option.value.toString()));

    const chipData = {
        title: selectedOptions.map(option => option.label).join(', '),
        label: `${filter.label}${selectedOptions.length > 1 ? `s (${selectedOptions.length})` : ''}`
    };

    const { title, label } = chipData;

    return (
        <Tooltip title={title} arrow>
            <Chip label={label} onClick={onClick} onDelete={() => handleDelete(filter.name)} deleteIcon={<Icon>close</Icon>} />
        </Tooltip>
    );
}
